import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import { Section } from "../Section";
import { IShape, IShapeChooserTranslations } from "../ShapeChooser";

export type ShapeSectionProps = {
  shapes: IShape[];
  shape: string;
  onChangeComplete: (shape: string) => void;
  onOpenShapes?: () => void;
  open?: boolean;

  translations: {
    shapeLabel: string;
    selectYourShape: string;
    shapes: IShapeChooserTranslations["shapes"];
  };
};

const ShapeSection = (props: ShapeSectionProps) => {
  return (
    <Section
      key={"shape"}
      number={2}
      title={props.translations.selectYourShape}
      data-section="Shape"
      sx={{ px: { md: "23px" } }}
    >
      <FormControl fullWidth>
        <InputLabel id="select-shape-label">
          {props.translations.shapeLabel}
        </InputLabel>
        <Select
          labelId="select-shape-label"
          id="select-shape"
          value={props.shape}
          label={props.translations.shapeLabel}
          sx={{
            maxWidth: {
              xs: "100%",
              md: "276px",
            },
          }}
          open={props.open}
          onOpen={props.onOpenShapes}
          onChange={(ev) => {
            props.onChangeComplete(ev.target.value);
          }}
        >
          {props.shapes.map((shape) => {
            return (
              <MenuItem key={shape.shape} value={shape.shape}>
                <Grid container>
                  <Grid item xs={6}>
                    {props.translations.shapes[shape.shape]}
                  </Grid>
                </Grid>
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Section>
  );
};

export default ShapeSection;
